/**
 * Base API
 * API for Base Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MenuConfigEntry { 
    type?: MenuConfigEntry.TypeEnum;
    element?: MenuConfigEntry.ElementEnum;
    parent?: MenuConfigEntry.ParentEnum;
    orderIndex?: number;
    deactivated?: boolean;
}
export namespace MenuConfigEntry {
    export type TypeEnum = 'MENU' | 'PUBLIC';
    export const TypeEnum = {
        MENU: 'MENU' as TypeEnum,
        PUBLIC: 'PUBLIC' as TypeEnum
    };
    export type ElementEnum = 'MENU_ROOT' | 'HOME' | 'POSTFACH' | 'RECHNUNGEN_GEBUEHREN' | 'GRUNDSTUECK' | 'GRUNDBUCH' | 'GRUNDBUCHGESCHAEFTE' | 'AUFGABEN_PENDENZEN' | 'EGVT' | 'RECHTE' | 'BERECHTIGTE_PERSONEN' | 'GRUNDBUCHMELDUNG' | 'ALTE_GRUNDBUCHMELDUNGEN' | 'ECH_0134_GRUNDBUCHMELDUNGEN' | 'PUBLIKATION' | 'TITELKONTROLLE' | 'VERMESSUNG' | 'ERWEITERTES_SUCHREGISTER' | 'GEOMETERGESCHAEFT' | 'GEBAEUDE' | 'AVGBS_AV_MUTATION' | 'AVGBS_GRUNDSTUECKBESCHRIEB' | 'NOTARIAT' | 'GEBAEUDE_UND_WOHNUNGSREGISTER' | 'GWR_GEBAEUDE' | 'GWR_BAUPROJEKTE' | 'AMTLICHE_BEWERTUNG' | 'NESKOAB' | 'STAMMDATEN' | 'STAMMPERSONEN' | 'ORGANISATORISCHE_EINHEITEN' | 'POLITISCHE_GEMEINDEN' | 'GEMEINDE_GEMEINDEKREIS' | 'CODES' | 'SYSTEM' | 'AUSWERTUNGEN' | 'IMPORT_EXPORT' | 'KONFIGURATION' | 'ECH_0134_EMPFAENGER' | 'UNTERSTUETZUNG' | 'PARAMETER' | 'FREMDSYSTEM' | 'E_PRAEFIXE' | 'MELDUNGSEMPFAENGER' | 'HOME_PUBLIC' | 'UNTERSTUETZUNG_PUBLIC';
    export const ElementEnum = {
        MENUROOT: 'MENU_ROOT' as ElementEnum,
        HOME: 'HOME' as ElementEnum,
        POSTFACH: 'POSTFACH' as ElementEnum,
        RECHNUNGENGEBUEHREN: 'RECHNUNGEN_GEBUEHREN' as ElementEnum,
        GRUNDSTUECK: 'GRUNDSTUECK' as ElementEnum,
        GRUNDBUCH: 'GRUNDBUCH' as ElementEnum,
        GRUNDBUCHGESCHAEFTE: 'GRUNDBUCHGESCHAEFTE' as ElementEnum,
        AUFGABENPENDENZEN: 'AUFGABEN_PENDENZEN' as ElementEnum,
        EGVT: 'EGVT' as ElementEnum,
        RECHTE: 'RECHTE' as ElementEnum,
        BERECHTIGTEPERSONEN: 'BERECHTIGTE_PERSONEN' as ElementEnum,
        GRUNDBUCHMELDUNG: 'GRUNDBUCHMELDUNG' as ElementEnum,
        ALTEGRUNDBUCHMELDUNGEN: 'ALTE_GRUNDBUCHMELDUNGEN' as ElementEnum,
        ECH0134GRUNDBUCHMELDUNGEN: 'ECH_0134_GRUNDBUCHMELDUNGEN' as ElementEnum,
        PUBLIKATION: 'PUBLIKATION' as ElementEnum,
        TITELKONTROLLE: 'TITELKONTROLLE' as ElementEnum,
        VERMESSUNG: 'VERMESSUNG' as ElementEnum,
        ERWEITERTESSUCHREGISTER: 'ERWEITERTES_SUCHREGISTER' as ElementEnum,
        GEOMETERGESCHAEFT: 'GEOMETERGESCHAEFT' as ElementEnum,
        GEBAEUDE: 'GEBAEUDE' as ElementEnum,
        AVGBSAVMUTATION: 'AVGBS_AV_MUTATION' as ElementEnum,
        AVGBSGRUNDSTUECKBESCHRIEB: 'AVGBS_GRUNDSTUECKBESCHRIEB' as ElementEnum,
        NOTARIAT: 'NOTARIAT' as ElementEnum,
        GEBAEUDEUNDWOHNUNGSREGISTER: 'GEBAEUDE_UND_WOHNUNGSREGISTER' as ElementEnum,
        GWRGEBAEUDE: 'GWR_GEBAEUDE' as ElementEnum,
        GWRBAUPROJEKTE: 'GWR_BAUPROJEKTE' as ElementEnum,
        AMTLICHEBEWERTUNG: 'AMTLICHE_BEWERTUNG' as ElementEnum,
        NESKOAB: 'NESKOAB' as ElementEnum,
        STAMMDATEN: 'STAMMDATEN' as ElementEnum,
        STAMMPERSONEN: 'STAMMPERSONEN' as ElementEnum,
        ORGANISATORISCHEEINHEITEN: 'ORGANISATORISCHE_EINHEITEN' as ElementEnum,
        POLITISCHEGEMEINDEN: 'POLITISCHE_GEMEINDEN' as ElementEnum,
        GEMEINDEGEMEINDEKREIS: 'GEMEINDE_GEMEINDEKREIS' as ElementEnum,
        CODES: 'CODES' as ElementEnum,
        SYSTEM: 'SYSTEM' as ElementEnum,
        AUSWERTUNGEN: 'AUSWERTUNGEN' as ElementEnum,
        IMPORTEXPORT: 'IMPORT_EXPORT' as ElementEnum,
        KONFIGURATION: 'KONFIGURATION' as ElementEnum,
        ECH0134EMPFAENGER: 'ECH_0134_EMPFAENGER' as ElementEnum,
        UNTERSTUETZUNG: 'UNTERSTUETZUNG' as ElementEnum,
        PARAMETER: 'PARAMETER' as ElementEnum,
        FREMDSYSTEM: 'FREMDSYSTEM' as ElementEnum,
        EPRAEFIXE: 'E_PRAEFIXE' as ElementEnum,
        MELDUNGSEMPFAENGER: 'MELDUNGSEMPFAENGER' as ElementEnum,
        HOMEPUBLIC: 'HOME_PUBLIC' as ElementEnum,
        UNTERSTUETZUNGPUBLIC: 'UNTERSTUETZUNG_PUBLIC' as ElementEnum
    };
    export type ParentEnum = 'MENU_ROOT' | 'HOME' | 'POSTFACH' | 'RECHNUNGEN_GEBUEHREN' | 'GRUNDSTUECK' | 'GRUNDBUCH' | 'GRUNDBUCHGESCHAEFTE' | 'AUFGABEN_PENDENZEN' | 'EGVT' | 'RECHTE' | 'BERECHTIGTE_PERSONEN' | 'GRUNDBUCHMELDUNG' | 'ALTE_GRUNDBUCHMELDUNGEN' | 'ECH_0134_GRUNDBUCHMELDUNGEN' | 'PUBLIKATION' | 'TITELKONTROLLE' | 'VERMESSUNG' | 'ERWEITERTES_SUCHREGISTER' | 'GEOMETERGESCHAEFT' | 'GEBAEUDE' | 'AVGBS_AV_MUTATION' | 'AVGBS_GRUNDSTUECKBESCHRIEB' | 'NOTARIAT' | 'GEBAEUDE_UND_WOHNUNGSREGISTER' | 'GWR_GEBAEUDE' | 'GWR_BAUPROJEKTE' | 'AMTLICHE_BEWERTUNG' | 'NESKOAB' | 'STAMMDATEN' | 'STAMMPERSONEN' | 'ORGANISATORISCHE_EINHEITEN' | 'POLITISCHE_GEMEINDEN' | 'GEMEINDE_GEMEINDEKREIS' | 'CODES' | 'SYSTEM' | 'AUSWERTUNGEN' | 'IMPORT_EXPORT' | 'KONFIGURATION' | 'ECH_0134_EMPFAENGER' | 'UNTERSTUETZUNG' | 'PARAMETER' | 'FREMDSYSTEM' | 'E_PRAEFIXE' | 'MELDUNGSEMPFAENGER' | 'HOME_PUBLIC' | 'UNTERSTUETZUNG_PUBLIC';
    export const ParentEnum = {
        MENUROOT: 'MENU_ROOT' as ParentEnum,
        HOME: 'HOME' as ParentEnum,
        POSTFACH: 'POSTFACH' as ParentEnum,
        RECHNUNGENGEBUEHREN: 'RECHNUNGEN_GEBUEHREN' as ParentEnum,
        GRUNDSTUECK: 'GRUNDSTUECK' as ParentEnum,
        GRUNDBUCH: 'GRUNDBUCH' as ParentEnum,
        GRUNDBUCHGESCHAEFTE: 'GRUNDBUCHGESCHAEFTE' as ParentEnum,
        AUFGABENPENDENZEN: 'AUFGABEN_PENDENZEN' as ParentEnum,
        EGVT: 'EGVT' as ParentEnum,
        RECHTE: 'RECHTE' as ParentEnum,
        BERECHTIGTEPERSONEN: 'BERECHTIGTE_PERSONEN' as ParentEnum,
        GRUNDBUCHMELDUNG: 'GRUNDBUCHMELDUNG' as ParentEnum,
        ALTEGRUNDBUCHMELDUNGEN: 'ALTE_GRUNDBUCHMELDUNGEN' as ParentEnum,
        ECH0134GRUNDBUCHMELDUNGEN: 'ECH_0134_GRUNDBUCHMELDUNGEN' as ParentEnum,
        PUBLIKATION: 'PUBLIKATION' as ParentEnum,
        TITELKONTROLLE: 'TITELKONTROLLE' as ParentEnum,
        VERMESSUNG: 'VERMESSUNG' as ParentEnum,
        ERWEITERTESSUCHREGISTER: 'ERWEITERTES_SUCHREGISTER' as ParentEnum,
        GEOMETERGESCHAEFT: 'GEOMETERGESCHAEFT' as ParentEnum,
        GEBAEUDE: 'GEBAEUDE' as ParentEnum,
        AVGBSAVMUTATION: 'AVGBS_AV_MUTATION' as ParentEnum,
        AVGBSGRUNDSTUECKBESCHRIEB: 'AVGBS_GRUNDSTUECKBESCHRIEB' as ParentEnum,
        NOTARIAT: 'NOTARIAT' as ParentEnum,
        GEBAEUDEUNDWOHNUNGSREGISTER: 'GEBAEUDE_UND_WOHNUNGSREGISTER' as ParentEnum,
        GWRGEBAEUDE: 'GWR_GEBAEUDE' as ParentEnum,
        GWRBAUPROJEKTE: 'GWR_BAUPROJEKTE' as ParentEnum,
        AMTLICHEBEWERTUNG: 'AMTLICHE_BEWERTUNG' as ParentEnum,
        NESKOAB: 'NESKOAB' as ParentEnum,
        STAMMDATEN: 'STAMMDATEN' as ParentEnum,
        STAMMPERSONEN: 'STAMMPERSONEN' as ParentEnum,
        ORGANISATORISCHEEINHEITEN: 'ORGANISATORISCHE_EINHEITEN' as ParentEnum,
        POLITISCHEGEMEINDEN: 'POLITISCHE_GEMEINDEN' as ParentEnum,
        GEMEINDEGEMEINDEKREIS: 'GEMEINDE_GEMEINDEKREIS' as ParentEnum,
        CODES: 'CODES' as ParentEnum,
        SYSTEM: 'SYSTEM' as ParentEnum,
        AUSWERTUNGEN: 'AUSWERTUNGEN' as ParentEnum,
        IMPORTEXPORT: 'IMPORT_EXPORT' as ParentEnum,
        KONFIGURATION: 'KONFIGURATION' as ParentEnum,
        ECH0134EMPFAENGER: 'ECH_0134_EMPFAENGER' as ParentEnum,
        UNTERSTUETZUNG: 'UNTERSTUETZUNG' as ParentEnum,
        PARAMETER: 'PARAMETER' as ParentEnum,
        FREMDSYSTEM: 'FREMDSYSTEM' as ParentEnum,
        EPRAEFIXE: 'E_PRAEFIXE' as ParentEnum,
        MELDUNGSEMPFAENGER: 'MELDUNGSEMPFAENGER' as ParentEnum,
        HOMEPUBLIC: 'HOME_PUBLIC' as ParentEnum,
        UNTERSTUETZUNGPUBLIC: 'UNTERSTUETZUNG_PUBLIC' as ParentEnum
    };
}


